// GENERATED FILE - DO NOT MODIFY

export enum RefundActionDto {
    IfAllowed = "IfAllowed",
    Refund = "Refund",
    NoRefund = "NoRefund",
}